import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLSWithExpiry } from './helpers';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = getLSWithExpiry('authKey');
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;